import React from 'react'

const Baner = (props) => {
  return (
    <div className='flex mx-auto !z-10 pt-14 sm:pt-28'>
        <div className='text-center absolute !z-10 w-full pt-10 px-5 lg:pt-28'>
          <div className='max-w-[460px] px-2 sm:px-5 md:px-10 mx-auto bg-white py-2 sm:py-5 bg-opacity-80 rounded-xl'>
            <h1 className='uppercase font-semibold text-lg md:text-3xl'>{props.text}</h1>
            <p className='text-sm sm:text-base pt-3'>{props.text2}</p>
          </div>
        </div>
        <div className='w-full'>
          <img src={props.bg} alt="background" className='object-cover w-full max-h-[350px] lg:max-h-[450px]'/>
        </div>
    </div>
  )
}

export default Baner